import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './PartnerPortalControls.scss';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';

const PartnerPortalControls = props => {
  const { tab, changeTab, selectedFilter, setSelectedFilter, curSearchVal, setCurSearchVal, filterOptions } = props;
  const { giftingRequests, discountCodes } = props;

  const openRequests = giftingRequests.filter(r => !r.userRejected && !r.userAccepted && r.brandAccepted);

  const [openFilter, setOpenFilter] = useState(false);
  const currentFilter = _.find(filterOptions, { label: selectedFilter?.label }) || filterOptions[0];

  const changeFilter = option => {
    setCurSearchVal('');
    setSelectedFilter(option);
    setOpenFilter(false);
  };

  const resetFilters = e => {
    e.stopPropagation();
    changeFilter(filterOptions[0]);
  };

  const changeSearchVal = e => {
    setSelectedFilter(null);
    setCurSearchVal(e.target.value);
  };

  return (
    <div className='partner-portal-controls-outer'>
      <div className='partner-portal-controls-inner'>
        <div className='control-bar-section' id='tabs'>
          <div className={cn('tab-container', { active: tab === 'gifting' })} onClick={() => changeTab('gifting')}>
            <span>
              Gifting
              {openRequests.length ? (
                <span className='tab-notification'>{openRequests.length} NEW</span>
              ) : (
                giftingRequests.length > 0 && <span className='tab-notification'>{giftingRequests.length}</span>
              )}
            </span>
          </div>
          <div className={cn('tab-container', { active: tab === 'codes' })} onClick={() => changeTab('codes')}>
            <span>
              discount codes
              {discountCodes.length > 0 && <span className='tab-notification'>{discountCodes.length}</span>}
            </span>
          </div>
        </div>
        {!_.every(filterOptions, { count: 0 }) && (
          <div className='control-bar-section' id='search-and-filter'>
            {tab === 'gifting' && (
              <OutsideClickHandler onOutsideClick={() => setOpenFilter(false)}>
                <div className='filter-container'>
                  <div className='filter-label' onClick={() => setOpenFilter(!openFilter)}>
                    {currentFilter?.label !== 'Show All' && <FontAwesomeIcon onClick={resetFilters} icon={faTimesCircle} />}
                    {currentFilter?.label !== 'Show All' ? currentFilter?.label : <>Filter Status&nbsp;&nbsp;&nbsp;&nbsp;+</>}
                  </div>
                  {openFilter && (
                    <div className='filter-dropdown'>
                      {filterOptions.map(option => {
                        const { label, count } = option;

                        if (!count) return null;
                        return (
                          <div
                            className={cn('filter-option', {
                              active: _.isEqual(option.label, selectedFilter?.label) || (!selectedFilter?.label && label === 'Show All')
                            })}
                            key={label}
                            onClick={() => changeFilter(option)}
                          >
                            {option.label} ({option.count})
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </OutsideClickHandler>
            )}
            <div className='search-container'>
              <input type='text' value={curSearchVal} className='gifting-search-input' onChange={changeSearchVal} placeholder='Search' />
              <FontAwesomeIcon icon={faSearch} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PartnerPortalControls.propTypes = {
  tab: PropTypes.string.isRequired,
  changeTab: PropTypes.func.isRequired,

  curSearchVal: PropTypes.string.isRequired,
  setCurSearchVal: PropTypes.func.isRequired,
  selectedFilter: PropTypes.object,
  setSelectedFilter: PropTypes.func.isRequired,
  filterOptions: PropTypes.array.isRequired,

  giftingRequests: PropTypes.array.isRequired,
  discountCodes: PropTypes.array.isRequired
};

export default PartnerPortalControls;
